import React from 'react';

const SettingsCountriesPage = React.lazy(() => import('../pages/settings/SettingsCountriesPage/SettingsCountriesPage'));
const SettingsCountryPage = React.lazy(() => import('../pages/settings/SettingsCountryPage/SettingsCountryPage'));
const SettingsDisciplinesPage = React.lazy(() => import('../pages/settings/SettingsDisciplinesPage/SettingsDisciplinesPage'));
const SettingsGeneralPage = React.lazy(() => import('../pages/settings/SettingsGeneralPage/SettingsGeneralPage'));
const SettingsLearningObjectivesPage = React.lazy(() => import('../pages/settings/SettingsLearningObjectivesPage/SettingsLearningObjectivesPage'));

const SettingsEvaluationCategoriesPage = React.lazy(() => import('../pages/settings/SettingsEvaluationCategoriesPage/SettingsEvaluationCategoriesPage'));
const SettingsEvaluationPeriodsPage = React.lazy(() => import('../pages/settings/SettingsEvaluationPeriodsPage/SettingsEvaluationPeriodsPage'));
const SettingsEvaluationScalesPage = React.lazy(() => import('../pages/settings/SettingsEvaluationScalesPage/SettingsEvaluationScalesPage'));
const SettingsTenantParamsPage = React.lazy(() => import('../pages/settings/SettingsTenantParamsPage/SettingsTenantParamsPage'));

export const PATH_SETTINGS = '/settings';
export const PATH_SETTINGS_COUNTRIES = '/settings-countries';
export const PATH_SETTINGS_COUNTRY = '/settings-country/:guid/:step?';
export const PATH_SETTINGS_DISCIPLINES = '/settings-disciplines';
export const PATH_SETTINGS_LEARNING_OBJECTIVES = '/settings-learning-objectives';
export const PATH_SETTINGS_CATEGORIES = '/settings-categories';
export const PATH_SETTINGS_PERIODS = '/settings-periods';
export const PATH_SETTINGS_SCALES = '/settings-scales';
export const PATH_SETTINGS_TENANT_PARAMS = '/settings-tenant-params';

const PAGE_SETTINGS = {
  component: SettingsGeneralPage,
  path: PATH_SETTINGS,
};

const PAGE_SETTINGS_COUNTRIES = {
  component: SettingsCountriesPage,
  path: PATH_SETTINGS_COUNTRIES,
};

const PAGE_SETTINGS_COUNTRY = {
  component: SettingsCountryPage,
  path: PATH_SETTINGS_COUNTRY,
};

const PAGE_SETTINGS_DISCIPLINES = {
  component: SettingsDisciplinesPage,
  path: PATH_SETTINGS_DISCIPLINES,
};

const PAGE_LEARNING_OBJECTIVES = {
  component: SettingsLearningObjectivesPage,
  path: PATH_SETTINGS_LEARNING_OBJECTIVES,
};

const PAGE_SETTINGS_CATEGORIES = {
  path: PATH_SETTINGS_CATEGORIES,

  component: SettingsEvaluationCategoriesPage,
};

const PAGE_SETTINGS_PERIODS = {
  component: SettingsEvaluationPeriodsPage,
  path: PATH_SETTINGS_PERIODS,
};

const PAGE_SETTINGS_SCALES = {
  component: SettingsEvaluationScalesPage,
  path: PATH_SETTINGS_SCALES,
};

const PAGE_SETTINGS_TENANT_PARAMS = {
  component: SettingsTenantParamsPage,
  path: PATH_SETTINGS_TENANT_PARAMS,
};

// IMPORTANT: The order in which the pages are added is important
export default [
  PAGE_SETTINGS,
  PAGE_SETTINGS_COUNTRY,
  PAGE_SETTINGS_COUNTRIES,
  PAGE_SETTINGS_DISCIPLINES,
  PAGE_LEARNING_OBJECTIVES,
  PAGE_SETTINGS_CATEGORIES,
  PAGE_SETTINGS_SCALES,
  PAGE_SETTINGS_PERIODS,
  PAGE_SETTINGS_TENANT_PARAMS,
];
